import type { Product } from '~/services/api.server';

export function validCombination(product: Product, color?: string) {
  const transformedAttributes = transformProductAttributes(product);
  const seedIndexesComb = Array(transformedAttributes.length).fill(0);
  seedIndexesComb[seedIndexesComb.length - 1] = -1;

  let initialComb = getNextCombination(transformedAttributes, seedIndexesComb);
  let nextComb = initialComb;
  let combination: Combination | undefined;

  do {
    combination = getValidCombination(transformedAttributes, product.unavailable_variants, nextComb, color);
    nextComb = getNextCombination(transformedAttributes, nextComb);
  } while (!sameArrayContents(initialComb, nextComb) && combination === undefined);
  return combination;
}

function getNextCombination(transformedProductAttributes: Array<string | any>, attrIndexes: Array<number>) {
  let indexes = [...attrIndexes];
  for (let i = indexes.length - 1; i >= 0; i--) {
    indexes[i]++;
    if (indexes[i] < transformedProductAttributes[i][1].length) {
      break;
    } else {
      indexes[i] = 0;
    }
  }

  return indexes;
}

function getValidCombination(
  transformedAttributes: Array<string | any>,
  unavailableVariants: Array<string>,
  attrIndexes: Array<number>,
  color?: string
) {
  let attributes: Combination = {};
  const combination = transformedAttributes
    .map(([k, v], i) => {
      attributes[pluralToSingular(transformedAttributes[i][0])] = v[attrIndexes[i]];
      return v[attrIndexes[i]];
    })
    .join(',');

  if (color) {
    if (!unavailableVariants.includes(combination) && combination.includes(color)) {
      return attributes;
    }
  } else {
    if (!unavailableVariants.includes(combination)) {
      return attributes;
    }
  }
}

function sameArrayContents(indexArray1: Array<number>, indexArray2: Array<number>) {
  return indexArray1.length === indexArray2.length && indexArray1.every((v, i) => v === indexArray2[i]);
}

function transformProductAttributes(product: Product) {
  return Object.entries(product.available_attributes).map(([k, v]) => {
    const values = v.map((v) => v.name);
    return [pluralToSingular(String(k)), values];
  });
}

type Combination = {
  [key: string]: string;
};

/*
  This transforms the props "colors" to "color", "size" to "sizes" and "book_types" to "book_type" because
  productAttributes needs the attributes in singular. In the future if there are new Products properties, a change
  may be necessary
*/

export function pluralToSingular(attribute: string) {
  if (attribute.endsWith('s')) {
    return attribute.slice(0, attribute.length - 1);
  } else {
    return attribute;
  }
}
